import { useState } from "react";
import { SortingState } from "@tanstack/react-table";

export const useDataTableSorting = (initialState: SortingState) => {
  return useState<SortingState>(initialState);
};
